module.exports = __webpack_public_path__ + "media/images/PadgettIcon-812ea98994918bbadf8811f7f503f828.png";